<app-header-toolbar title="View">
</app-header-toolbar>

<ion-content [scrollY]="false"
             [scrollX]="false">
    <div class="centered-content-wrapper">

        <div class="actionsTitle">Select Content Type</div>

        <ng-select class="content-selector"
                   [items]="contentTypes"
                   bindLabel="name"
                   bindValue="id"
                   autofocus
                   [(ngModel)]="selectedContentType"
                   (change)="onContentTypeChange($event)">
        </ng-select>

        <ng-container *ngIf="selectedContentType==='CONTENT_INSPECTION_BATCH'">
            <div class="actionsTitle">Select Inspection Batch</div>

            <ng-select class="content-selector"
                       [items]="(inspectionBatches$ | async)"
                       bindLabel="inspectionBatchName"
                       bindValue="id"
                       autofocus
                       [(ngModel)]="selectedContent">
            </ng-select>

            <ion-button [disabled]="selectedContent === null"
                        (click)="inspectClicked()">
                {{buttonText}}
            </ion-button>
        </ng-container>

        <ng-container *ngIf="selectedContentType==='CONTENT_DEPOT'">
            <div class="actionsTitle">Select {{config.getDepotLabel()}}</div>

            <ng-select class="content-selector"
                       [items]="(depots$ | async)"
                       bindLabel="name"
                       bindValue="id"
                       autofocus
                       [(ngModel)]="selectedContent">
            </ng-select>

            <ion-button [disabled]="selectedContent === null"
                        (click)="inspectClicked()">
                {{buttonText}}
            </ion-button>
        </ng-container>

        <ng-container *ngIf="selectedContentType==='CONTENT_POLE_NAME'">
            <div class="actionsTitle">Enter Pole Name</div>

            <ion-item>
                <ion-input [(ngModel)]="selectedContent"></ion-input>
            </ion-item>

            <ion-button [disabled]="selectedContent === null"
                        (click)="inspectClicked()">
                {{buttonText}}
            </ion-button>
        </ng-container>
        <ng-container *ngIf="selectedContentType==='CONTENT_POLE_ID'">
            <div class="actionsTitle">Enter Pole ID</div>

            <ion-item class="content-selector">
                <ion-input [(ngModel)]="selectedContent"></ion-input>
            </ion-item>

            <ion-button [disabled]="selectedContent === null"
                        (click)="inspectClicked()">
                {{buttonText}}
            </ion-button>
        </ng-container>
    </div>
</ion-content>
